import React from 'react';

import Popup from '../../Popup';
import AdjustRatingContent from '../../GetRated/AdjustRatingContent';
import styles from './adjustRatingPopUp.scss';

const AdjustRatingPopUp = ({
    auth,
    onCloseClick,
}) => {
    return (
        <Popup
            className={`popup-md`}
            popUpClassName={`${styles.adjustRatingPopUp}`}
            onCloseClick={onCloseClick}
            config={{ noPadding: true }}
            data-testid="modal.adjust-rating"
        >
            <AdjustRatingContent
                user={auth.user}
                forceMobileUi={true}
                ratingSubmitted={onCloseClick}
            />
        </Popup>
    );
};

export default AdjustRatingPopUp;
